import { Modal, Button, Form, Input, InputNumber, Select, Radio, Checkbox, Row, Col, Image } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../contexts/AppContext';
import APIList from '../../../../http/ApiList';
import { GLOBAL_EVENT } from '../../../../consts/common/global-event';

import * as Icons from '@ant-design/icons';

const Icon = ({ name }) => {
  const AntIcon = Icons[name];
  return AntIcon ? <AntIcon /> : <Image width={16} preview={false} src={name} />;
};

const ButtonTriggerModal: React.FC<any> = (props) => {
  const { authInfo, globalEvent, setGlobalEvent } = useContext(AppContext);
  const { property } = props;
  const [showModal, setShowModal] = useState<any>(false);
  const [formItemList, setFormItemList] = useState<any>([]);
  const [buttonStyle, setButtonStyle] = useState<any>({});
  const [form] = Form.useForm();

  const getFormData = (event: string) => {
    APIList.getCustomizeLayoutData()
      .post({ email: authInfo?.user?.attributes?.email || '', property, event })
      .then((res: any) => {
        setFormItemList(res.data);
      });
  };

  useEffect(() => {
    if (!property || !property.style || property.style.length === 0) {
      return;
    }
    const style = {};
    property.style.forEach((item) => {
      style[item.key] = item.value;
    });
    setButtonStyle(style);
  }, [property]);

  useEffect(() => {
    if (!globalEvent) {
      return;
    }
    if (
      (property.dataSource &&
        property.dataSource.triggerEvent &&
        property.dataSource.triggerEvent.find((triggerEvent) => {
          return triggerEvent.event === globalEvent.eventType;
        })) ||
      globalEvent.eventType === GLOBAL_EVENT.PAGE_INIT
    ) {
      getFormData(globalEvent);
    }
    if (globalEvent.eventType === GLOBAL_EVENT.OPEN_BUTTON_TRIGGER_MODAL) {
      setShowModal(true);
    } else if (globalEvent.eventType === GLOBAL_EVENT.CLOSE_BUTTON_TRIGGER_MODAL) {
      setShowModal(false);
    }
  }, [globalEvent]);

  const setFormItem = (item) => {
    switch (item.type) {
      case 'flow':
        const imageUrl = '/assets/gai/flow.png';
        return (
          <Form.Item
            style={{ width: item.width || '100%', margin: '6px 0' }}
            name={item.variable || item.title}
            label={item.title}
            rules={[{ required: item.required, message: `Missing ${item.title}` }]}
          >
            <div
              style={{
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundImage: `url(${imageUrl})`,
                width: 800,
                height: 300,
              }}
            ></div>
          </Form.Item>
        );
      case 'input':
        return (
          <Form.Item
            style={{ width: item.width || '100%', margin: '6px 0' }}
            name={item.variable || item.title}
            label={item.title}
            rules={[{ required: item.required, message: `Missing ${item.title}` }]}
          >
            <Input style={{ width: '100%' }} placeholder={item.placeholder || ''} />
          </Form.Item>
        );
      case 'inputNumber':
        const hasAfter = item.title.split('[');
        let addonAfter = '';
        if (hasAfter[1]) {
          addonAfter = hasAfter[1].replace(']', '');
        }
        return (
          <Form.Item
            style={{ width: item.width || '100%', margin: '6px 0' }}
            name={item.variable || hasAfter[0]}
            label={hasAfter[0]}
            rules={[{ required: item.required, message: `Missing ${hasAfter[0]}` }]}
          >
            <InputNumber style={{ width: '100%' }} defaultValue={item.defaultValue} addonAfter={addonAfter} />
          </Form.Item>
        );
      case 'radio': {
        if (item.style === 'button') {
          return (
            <Form.Item
              label={item.title}
              name={item.variable || item.title}
              style={{ width: item.width || '100%', margin: '6px 0' }}
              rules={[{ required: item.required, message: `Missing ${item.title}` }]}
            >
              <Radio.Group optionType="button" buttonStyle="solid" options={item.values} style={{ width: '100%' }} />
            </Form.Item>
          );
        } else {
          return (
            <Form.Item
              label={item.title}
              name={item.variable || item.title}
              style={{ width: item.width || '100%', margin: '6px 0' }}
              rules={[{ required: item.required, message: `Missing ${item.title}` }]}
            >
              <Radio.Group options={item.values} style={{ width: '100%' }} />
            </Form.Item>
          );
        }
      }
      case 'checkbox':
        return (
          <Form.Item
            style={{ width: item.width || '100%', margin: '6px 0' }}
            name={item.variable || item.title}
            label={item.title}
            rules={[{ required: item.required, message: `Missing ${item.title}` }]}
          >
            <Checkbox.Group style={{ width: '100%' }}>
              <Row>
                {item.values ? (
                  item.values.map((option) => {
                    return (
                      <Col span={6}>
                        <Checkbox value={option.value}>{option.label}</Checkbox>
                      </Col>
                    );
                  })
                ) : (
                  <></>
                )}
              </Row>
            </Checkbox.Group>
          </Form.Item>
        );
      case 'checkboxCard':
        return (
          <Form.Item
            style={{ width: item.width || '100%', margin: '6px 0' }}
            name={item.variable || item.title}
            label={item.title}
            rules={[{ required: item.required, message: `Missing ${item.title}` }]}
          >
            <Checkbox.Group style={{ width: '100%' }}>
              <Row>
                {item.values ? (
                  item.values.map((option) => {
                    return (
                      <Col span={8}>
                        <Checkbox
                          value={option.value}
                          className="checkbox-card"
                          style={{ padding: 20, marginBottom: 12, border: '1px solid #eee' }}
                        >
                          <div style={{ textAlign: 'center', marginBottom: 20 }}>{option.label}</div>
                          <div>
                            <Button style={{ margin: '0 4px' }}>スキル</Button>
                            <Button style={{ margin: '0 4px' }}>性格</Button>
                          </div>
                        </Checkbox>
                      </Col>
                    );
                  })
                ) : (
                  <></>
                )}
              </Row>
            </Checkbox.Group>
          </Form.Item>
        );
      case 'button': {
        return (
          <div style={{ display: 'inline-block', float: item.position }}>
            <Button type="primary" style={{ margin: '0 4px' }}>
              {item.title}
            </Button>
          </div>
        );
      }

      case 'multiSelect':
        return (
          <Form.Item
            style={{ width: item.width || '100%', margin: '6px 0' }}
            name={item.variable || item.title}
            label={item.title}
            rules={[{ required: item.required, message: `Missing ${item.title}` }]}
          >
            <Select
              defaultValue={item.defaultValue}
              style={{ width: '100%' }}
              options={item.values.map((item) => {
                return { value: item, label: item };
              })}
              maxTagCount={1}
              mode="multiple"
            />
          </Form.Item>
        );
      case 'singleSelect':
        return (
          <Form.Item
            style={{ width: item.width || '100%', margin: '6px 0' }}
            name={item.variable || item.title}
            label={item.title}
            rules={[{ required: item.required, message: `Missing ${item.title}` }]}
          >
            <Select
              defaultValue={item.defaultValue}
              value={item.value || item.defaultValue}
              style={{ width: '100%' }}
              options={item.values.map((item) => {
                return { value: item, label: item };
              })}
            />
          </Form.Item>
        );
      default:
        break;
    }
  };
  return (
    <div style={buttonStyle}>
      {(property.triggerButtonText && property.triggerButtonText.length > 0) ||
      (property.triggerButtonIcon && property.triggerButtonIcon.length > 0) ? (
        <Button
          type="primary"
          onClick={() => {
            setShowModal(!showModal);
          }}
        >
          {property.triggerButtonText ? property.triggerButtonText : <Icon name={property.triggerButtonIcon} />}
        </Button>
      ) : (
        <></>
      )}
      <Modal
        title={property.modalTitle}
        centered
        open={showModal}
        width={1000}
        maskClosable={false}
        onCancel={() => setShowModal(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              form.resetFields();
              setShowModal(false);
            }}
          >
            取り消し
          </Button>,
          <Button
            type="primary"
            key="ok"
            htmlType="submit"
            onClick={() => {
              form.submit();
            }}
          >
            作成
          </Button>,
        ]}
      >
        <Form
          name="basic"
          form={form}
          layout={'inline'}
          autoComplete="off"
          preserve={false}
          labelCol={{ span: 2 }}
          style={{ padding: 12 }}
          onFinish={(values) => {
            const eventInfo = {
              eventType: property.triggerEventType,
              data: values,
            };
            setGlobalEvent(eventInfo);
            setShowModal(false);
            setTimeout(() => {
              form.resetFields();
            }, 500);
          }}
        >
          {formItemList.map((item) => {
            return setFormItem(item);
          })}
        </Form>
      </Modal>
    </div>
  );
};

export default ButtonTriggerModal;
